<template>
  <b-list-group flush class="my--3">
    <b-row align-v="center">
      <b-col>
        <h4>{{yearlyV}}</h4>
        <h5>
          <span>Data Volume this Year (MB)</span>
          <span class="float-right">{{yearlyP}}</span>
        </h5>
        <b-progress
        >
          <b-progress-bar variant="danger" :value="yearlyP"></b-progress-bar>
        </b-progress>
      </b-col>
    </b-row>

    <b-row align-v="center">
      <b-col>
        <h4>{{monthlyV}}</h4>
        <h5>
          <span>Data Volume this Month (MB)</span>
          <span class="float-right">{{monthlyP}}</span>
        </h5>
        <b-progress
        >
          <b-progress-bar variant="primary"  :value="monthlyP"></b-progress-bar>
        </b-progress>
      </b-col>
    </b-row>

    <b-row align-v="center">
      <b-col>
        <h4>{{dailyV}}</h4>
        <h5>
          <span>Data Volume today (MB)</span>
          <span class="float-right">{{dailyP}}</span>
        </h5>
        <b-progress
        >
          <b-progress-bar variant="default"  :value="dailyP"></b-progress-bar>
        </b-progress>
      </b-col>
    </b-row>

  </b-list-group>
</template>
<script>
  import { BaseProgress } from '../../../components';

  export default {
    name: 'progress-track-list',
    props: {
      itemLimit: {
        type: Number,
        default: 4
      },
    },
    components: {
      BaseProgress
    },
    data() {
      return {
        yearlyV: '0',
        yearlyP: 0,
        monthlyV: '0',
        monthlyP: 0,
        dailyV: '0',
        dailyP: 0,
      }
    },
    methods: {

    },
    mounted() {
      this.$root.$on('dataVolumeAverage', (data) => {
        this.yearlyV = data.yearlyV;
        this.yearlyP = data.yearlyP;
        this.monthlyV = data.monthlyV;
        this.monthlyP = data.monthlyP;
        this.dailyV = data.dailyV;
        this.dailyP = data.dailyP;
      })
    },
  }
</script>
